export default function upsellProducts(state = {}, { type, payload }) {
  switch (type) {
    case 'RECEIVE_PRODUCT_UPSELL':
      const { upsellProductGroups, productUpsellPermalinks } = payload ?? []
      const updatedState = {
        ...state,
        upsellProductGroups,
        productUpsellPermalinks,
      }
      return updatedState
    default:
      return state
  }
}
